import { InputSelectControl } from '@sequencehq/core-components'

interface DatePresetSelectProps {
  value: string
  onChangeDatePreset: (preset: string) => void
}

export const DatePresetSelect = ({
  value,
  onChangeDatePreset
}: DatePresetSelectProps) => {
  const PRESET_INPUT_OPTIONS = [
    {
      label: 'This month',
      value: 'this_month'
    },
    {
      label: 'Last 3 months',
      value: '3_months'
    },
    {
      label: 'Last 6 months',
      value: '6_months'
    },
    {
      label: 'Last year',
      value: 'last_year'
    }
  ]

  return (
    <InputSelectControl
      data-testid="insights.datePresetSelect"
      options={PRESET_INPUT_OPTIONS}
      initialValue={value}
      onChange={onChangeDatePreset}
      placeholder="Choose date range"
      triggerStyle={{ width: '200px' }}
    />
  )
}
